import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

class Blockquote {
    constructor(root) {
        this.root = root;
        
        this.init();
    }

    init() {
        this.anim = gsap.fromTo(this.root, {
            opacity: 0,
        }, {
            opacity: 1,
            duration: 0.3,
            ease: 'out',
            scrollTrigger: {
              trigger: this.root,
              start: 'top 90%',
              end: 'bottom 10%',
              invalidateOnRefresh: true,
              // markers: true,
            },
        });
    }

    destroy() {
        this.anim && this.anim.kill();
    }
}

export default {
    when() {
        return document.querySelectorAll('[data-blockquote]').length > 0
    },

    created() {
        this.instances = [];
        document.querySelectorAll('[data-blockquote]').forEach(root => {
            const inst = new Blockquote(root)
            this.instances.push(inst);
        })
    },

    destroyed() {
        this.instances.forEach(instance => {
            instance.destroy && instance.destroy();
        });
    }
}
